export default {
  // items de categorias para lista con checkbox
  dataCategoryFilter: [],
  csv: null,
  csvError: false
};
